import { render, staticRenderFns } from "./CompanionTopic.vue?vue&type=template&id=a156e666&scoped=true&lang=pug&"
import script from "./CompanionTopic.vue?vue&type=script&lang=js&"
export * from "./CompanionTopic.vue?vue&type=script&lang=js&"
import style0 from "./CompanionTopic.vue?vue&type=style&index=0&id=a156e666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a156e666",
  null
  
)

export default component.exports